import { ICountry } from "@app/common/types";
import { createContext } from "react";

export interface ILoyaltyMemberDetails {
    // todo: Use when properly integrated
    tierId: string;
    tierName: string;
    title: string;
    name: string;
    email: string;
    registerDate: string;
    promocode: string | null;
}

export interface ILoyaltyContext {
    index: string;
    accessToken: string;
    memberDetails: ILoyaltyMemberDetails | null;
    countries: ICountry[];
    setIndex: (index: string) => void;
    setAccessToken: (accessToken: string) => void;
    setMemberDetails: (memberDetails: ILoyaltyMemberDetails | null) => void;
}

export const LoyaltyContext = createContext<ILoyaltyContext>({
    index: "",
    accessToken: "",
    memberDetails: null,
    countries: [],
    setIndex: () => {},
    setAccessToken: () => {},
    setMemberDetails: () => {},
});
